import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let Logic = class Logic extends Vue {
    // @Prop({default:{}})
    // opts!:any
    render(h) {
        return h('a-switch', { props: {
                disabled: true,
            } });
    }
};
Logic = tslib_1.__decorate([
    Component({ name: 'Logic' })
], Logic);
export default Logic;
